var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutWithContainer",
    [
      _c("template", { slot: "header" }, [
        _c("header", { attrs: { id: "content__header" } }, [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                width: "100%",
                "column-gap": "30px",
              },
            },
            [
              _c("h1", { staticStyle: { "margin-bottom": "0 !important" } }, [
                _vm._v("Search"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ai-checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.enableSynonyms,
                      expression: "enableSynonyms",
                    },
                  ],
                  attrs: { id: "public", type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.enableSynonyms)
                      ? _vm._i(_vm.enableSynonyms, null) > -1
                      : _vm.enableSynonyms,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.enableSynonyms,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.enableSynonyms = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.enableSynonyms = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.enableSynonyms = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    attrs: {
                      for: "public",
                      title:
                        "We will use AI to generate synonyms of your query to broaden results",
                    },
                  },
                  [_c("span", [_vm._v("Broaden search using AI?")])]
                ),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "vue-tabs",
        { ref: "tabs", on: { "tab-change": _vm.onTabChange } },
        [
          _c(
            "v-tab",
            { attrs: { id: "opportunities", title: "Opportunities" } },
            [
              _c("SearchPageOpportunities", {
                ref: "opportunities",
                attrs: {
                  query: _vm.searchQuery,
                  "enable-synonyms": _vm.enableSynonyms,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "madds", title: "MADDs" } },
            [
              _c("SearchPageMADDs", {
                ref: "madds",
                attrs: {
                  query: _vm.searchQuery,
                  "enable-synonyms": _vm.enableSynonyms,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "documents", title: "Documents" } },
            [
              _c("SearchPageDocuments", {
                ref: "documents",
                attrs: {
                  query: _vm.searchQuery,
                  "enable-synonyms": _vm.enableSynonyms,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "users", title: "Users" } },
            [
              _c("SearchPageUsers", {
                ref: "users",
                attrs: { query: _vm.searchQuery },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }